import { Box } from '@factorialco/deprecated-design-system'
import { MoneyBag } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

import AccountingSection from 'modules/expenses/pages/settings/Content/Accounting'
import SectionInfo from 'modules/expenses/pages/settings/ExpensePolicy/Components/_SectionInfo'

interface Props {
  hasLedgerAccountFeature: boolean
  canSeeLedgerAccounts: boolean
}

const Accounting = ({ hasLedgerAccountFeature, canSeeLedgerAccounts }: Props) => {
  return (
    <Box flexDirection="column" gap="s24" paddingX="s24" flexGrow>
      <SectionInfo
        icon={MoneyBag}
        title={i18n.t('expenses_v2.settings.accounting.title')}
        description={i18n.t('expenses_v2.settings.accounting.description')}
      />

      <AccountingSection
        hasFeature={hasLedgerAccountFeature}
        canGoToSettings={canSeeLedgerAccounts}
        hideTitle
      />
    </Box>
  )
}

export default Accounting
